
import { Link } from 'react-router-dom';

export default function ReadyToStartSection() {
  return (
    <section className="py-16 bg-[#BFE6CC]">
      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
          Ready To Get Started?
        </h2>
        <p className="text-xl text-white/90 mb-8" style={{ fontFamily: 'Open Sans, sans-serif' }}>
          Schedule a tour to see our facilities and meet our caring staff
        </p>
        <a
          href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0k1OqMamTOq1ExpTaS6c7VR0Lhle5KeyT0AGFk7YHDLzE4-szIujAIgxVPZOWdLdBtZPZUidWu"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#BFE6CC] font-semibold rounded-lg hover:bg-gray-50 hover:scale-105 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          Schedule a Tour
          <i className="ri-calendar-check-line ml-2"></i>
        </a>
      </div>
    </section>
  );
}
